/*
 * Module for the Service Purhase Change Payment Plan view
*/

rs.module("content/participant/member/servicepurchase/changepaymentplan",

    ["controls/components/event-banner", "common/select-helper"],

    function (eventBanner, selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, originalBalance) {

            var form = $.js(jsSelectors.form);

            form.js(jsSelectors.changeButton, { required: false }).click(function () {

                _clearErrors();

                toggleInputs(true);
                form.js(jsSelectors.repaymentDetail).hide();

                form.js(jsSelectors.changeButton).hide();
                form.js(jsSelectors.calculateButton).show();
                form.js(jsSelectors.cancelButton).show();
                form.js(jsSelectors.formActions).hide();
                form.js(jsSelectors.saveButton).setDisabled();
            });

            form.js(jsSelectors.calculateButton, { required: false }).click(function () {

                // Validate form before performing calc

                var validator = form.closest("form").validate();
                var isValid = validator.form();

                if (isValid) {

                    // show loading spinner
                    form.js(jsSelectors.spinner).show();

                    toggleInputs(false);
                    form.js(jsSelectors.repaymentDetail).hide();

                    $.get(
                        backendUrls.loadRepaymentDetail,
                        {
                            loanInterestPercent: form.js(jsSelectors.loanInterestPercent).val(),
                            downPaymentAmount: form.js(jsSelectors.downPayment).val(),
                            repayBeginDate: form.js(jsSelectors.repayBeginDate).val(),
                            paymentFrequency: form.js(jsSelectors.paymentFrequency).val(),
                            numberOfPayments: form.js(jsSelectors.numberOfPayments).val(),
                            originalBalance: originalBalance,
                            recalcPaymentPlanFlag: true
                        }
                    ).done(function (results) {

                        form.js(jsSelectors.repaymentDetail).html(results).show();

                        form.js(jsSelectors.changeButton).show();
                        form.js(jsSelectors.calculateButton).hide();
                        form.js(jsSelectors.cancelButton).hide();
                        form.js(jsSelectors.formActions).show();
                        form.js(jsSelectors.saveButton).setDisabled(false);

                    }).fail(function () {

                        toggleInputs(true);
                        form.js(jsSelectors.repaymentDetail).hide();

                        form.js(jsSelectors.changeButton).hide();
                        form.js(jsSelectors.calculateButton).show();
                        form.js(jsSelectors.cancelButton).show();
                        form.js(jsSelectors.formActions).hide();
                        form.js(jsSelectors.saveButton).setDisabled();

                    }).always(function () {
                        // hide loading spinner
                        form.js(jsSelectors.spinner).hide();
                    });
                }
            });

            function toggleInputs(enable) {
                form.js(jsSelectors.downPayment).prop("disabled", !enable);
                form.js(jsSelectors.numberOfPayments).prop("disabled", !enable);
                selectHelper.getHelper(form.js(jsSelectors.paymentFrequency)).setDisabled(!enable);
                form.js(jsSelectors.repayBeginDate).prop("disabled", !enable);
                form.js(jsSelectors.loanInterestPercent).prop("disabled", !enable);

                // if we are disabling the fields, copy their values into hidden fields so they can still be posted
                if (!enable) {
                    form.js(jsSelectors.loanInterestPercentHiddenField).val(form.js(jsSelectors.loanInterestPercent).val());
                    form.js(jsSelectors.downPaymentHiddenField).val(form.js(jsSelectors.downPayment).val());
                    form.js(jsSelectors.repayBeginDateHiddenField).val(form.js(jsSelectors.repayBeginDate).val());
                    form.js(jsSelectors.paymentFrequencyHiddenField).val(form.js(jsSelectors.paymentFrequency).val());
                    form.js(jsSelectors.numberOfPaymentsHiddenField).val(form.js(jsSelectors.numberOfPayments).val());
                }
            }

            //
            // Clear event banner and field errors
            //
            function _clearErrors() {

                // clear event banner
                eventBanner.removeAllMessages();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);